import { Directive, inject, Input, TemplateRef } from "@angular/core";

export type PageDetailWidgetPosition =
  | "top"
  | "top-left"
  | "middle"
  | "bottom"
  | "under-title";

@Directive({
  selector: "[pageDetailWidget]",
  standalone: false
})
export class PageDetailWidgetDirective {
  @Input("pageDetailWidget") position!: PageDetailWidgetPosition;

  templateRef = inject(TemplateRef<any>);
}
